import { vnModule_knockoutJS } from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import {
    XMLHttpRequestHandler,
    XMLHttpRequestHandler_requestType
} from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import {tagPerformanceArticleReport_template} from "../components/templates/tagPerformanceArticleReport_template";
import {vn_app_zone_notification} from "../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone_notification";

declare var ko: any;
declare var page: any;

export class tagPerformanceArticleReport extends vnModule_knockoutJS{

    protected XHRHdl: XMLHttpRequestHandler;
    protected tagPerformanceArticleReport_template: tagPerformanceArticleReport_template;

    protected getModuleName(){
        return "tagPerformanceArticleReport";
    }

    buildContent() : Array<Element>{

        this.tagPerformanceArticleReport_template = new tagPerformanceArticleReport_template( "tagPerformanceArticleReport", this.viewModel, this );

        this.template = this.tagPerformanceArticleReport_template;

        return [this.tagPerformanceArticleReport_template.build()];
    }

    public fillPage() : void{

        this.tagPerformanceArticleReport_template.buildDatePickerCalendar();

        this.getListFormData();
    }

    public getListFormData(): void{

        this.loadingIn(this.tagPerformanceArticleReport_template.builtTemplate);

        let usrReq_url: string = '/api/topicalityReport/references/';
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON([])] );
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url,usrReq_params, this);

        this.XHRHdl.onReadyStateFunction = this.onGetListFormDataReturn;
        this.XHRHdl.execute();
    }

    protected onGetListFormDataReturn(req, obj){

        return function(){

            obj.manageResponse(req, obj, function(){

                let responseParsed = JSON.parse(req.request.response);
                if(  req.request.status == 200  ){

                    obj.updateFilters(responseParsed.data);
                    obj.updateViewModelFromPath();

                    //Last page from History
                    let lastPage = "";
                    for (var i = obj.vnAppZone.app.routeHistory.length - 1; i >= 0; i--) {

                        if (!obj.vnAppZone.app.routeHistory[i].includes('/tag_performance_article_report')) {

                            lastPage = obj.vnAppZone.app.routeHistory[i];
                            break;
                        }
                    }

                    // fallback to referrer
                    if (lastPage == "") {

                        lastPage = document.referrer;
                    }

                    if (obj.tagPerformanceArticleReport_template.getTemplateViewModel().referrer() == "" && lastPage.includes('/tag_performance_report')) {

                        obj.tagPerformanceArticleReport_template.setReferrer(lastPage);
                    }

                    obj.getReportData();
                }
            });

            obj.loadingOut(obj.tagPerformanceArticleReport_template.builtTemplate);
        }
    }

    public getReportData(): void{

        this.loadingIn(this.tagPerformanceArticleReport_template.builtTemplate.children.namedItem("list-results"));

        this.tagPerformanceArticleReport_template.clearAndCloseSearchDrawer();

        let subViewModel = this.tagPerformanceArticleReport_template.getViewModelForRequest();
        let baseApiUrl = '/api/topicalityReport/article/get/';

        this.sendFilterCall(baseApiUrl, subViewModel, this.onGetReportData, XMLHttpRequestHandler_requestType.GET, 'getReportData');
    }

    protected onGetReportData(req, obj) {

        return function () {

            obj.manageResponse(req, obj, function () {

                let responseParsed = JSON.parse(req.request.response);
                if (req.request.status == 200) {

                    obj.updateList(responseParsed);
                }
            });

            obj.loadingOut(obj.tagPerformanceArticleReport_template.builtTemplate.children.namedItem("list-results"));
        }
    }

    protected getSearchQueryKeywordData(data) {

        if( this.XHRHdl ) {
            this.XHRHdl.cancelAndReset();
        }

        let vm = this.tagPerformanceArticleReport_template.getViewModelForRequest();

        let brand = [];
        brand.push(vm['filter']['idBrand']);

        let sqVm = {};
        sqVm['enabledPublishedDates'] = vm['filter']['isPublishDatesEnabled'];
        sqVm['filter'] = {};
        sqVm['filter']['startDataDate'] = vm['filter']['startDate'];
        sqVm['filter']['endDataDate'] = vm['filter']['endDate'];
        sqVm['filter']['startPublishedDate'] = vm['filter']['publishDateStart'];
        sqVm['filter']['endPublishedDate'] = vm['filter']['publishDateEnd'];
        sqVm['filter']['initiatives'] = vm['filter']['idInitiatives'];
        sqVm['filter']['intents'] = vm['filter']['idIntents'];
        sqVm['filter']['contentTypes'] = vm['filter']['idContentTypes'];
        sqVm['filter']['keywordPage'] = data.url;
        sqVm['filter']['article'] = {'idBrand': vm['filter']['idBrand'], 'idArticle': data.idArticle};

        let params: Array<Array<string>> = [];
        params.push(["data", ko.toJSON( sqVm )] );

        this.XHRHdl = new XMLHttpRequestHandler('/api/searchQuery/getKeywordData', params, this);
        this.XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
        let localCheck = this.XHRHdl.requestId;
        let _myThis = this;

        setTimeout(function(){

            if( localCheck == _myThis.XHRHdl.requestId ){
                _myThis.XHRHdl.onReadyStateFunction = _myThis.getSearchQueryKeywordDataReturn;
                _myThis.XHRHdl.execute();
            }
        }, 400);
    }

    protected getSearchQueryKeywordDataReturn(req, obj){

        return function (){

            obj.manageResponse(req, obj, function (){

                let responseParsed = JSON.parse(req.request.response);

                obj.tagPerformanceArticleReport_template.setSearchQueryKeywordData(responseParsed.data);
            });
        };
    }

    protected updateFilters(responseParsed: any) {

        this.tagPerformanceArticleReport_template.setViewModesItems();
        this.tagPerformanceArticleReport_template.setInitiativesItems(responseParsed.initiatives);
        this.tagPerformanceArticleReport_template.setIntentsItems(responseParsed.intents);
        this.tagPerformanceArticleReport_template.setContentTypesItems(responseParsed.groupedContentTypes);
        this.tagPerformanceArticleReport_template.setDataSourcesItems();
        this.tagPerformanceArticleReport_template.setGoogleSourcesItems();
        this.tagPerformanceArticleReport_template.setTableHeaderItems();
        this.tagPerformanceArticleReport_template.setIdBrand(this.getVnAppZone().app.params.idBrand);
        this.tagPerformanceArticleReport_template.setTag(this.getVnAppZone().app.params.idTag);

    }

    protected updateList(responseParsed: any) {

        this.tagPerformanceArticleReport_template.resetSelectedRows();
        this.tagPerformanceArticleReport_template.setBrand(responseParsed.brand);
        this.tagPerformanceArticleReport_template.setStatsTotals(responseParsed.statsTotals);
        this.tagPerformanceArticleReport_template.setTableData(responseParsed.paginatedResults.data);

        // update the paginator
        this.tagPerformanceArticleReport_template.setPaginationTotalCount(responseParsed.paginatedResults.totalCount);
    }

    protected filterSingleDateOnChange() {

        this.resetPageNumber();
        this.getReportData();
    }

    protected filterMultipleSelectorOnChange() {

        this.resetPageNumber();
        this.getReportData();
    }

    protected filterDateOnChange() {

        this.resetPageNumber();
        this.getReportData();
    }

    protected filterSimpleOnChange() {

        this.resetPageNumber();
        this.getReportData();
    }

    protected filterDropdownOnChange(){

        this.resetPageNumber();
        this.getReportData();
    }

    public dataReorder(id) {

        this.getReportData();
    }

    protected paginationOnPageClick(){

        this.getReportData();
    }

    private resetPageNumber(){

        // go back to page 1 in the pagination
        this.tagPerformanceArticleReport_template.resetPageNumber();
    }

    protected getMultipleAutoCompleteSuggestions(id, keyword) {

        let subViewModel = {
            filters      : {
                keyword : keyword,
                idBrands : [this.tagPerformanceArticleReport_template.getTemplateViewModel().idBrand],
                startDate: this.tagPerformanceArticleReport_template.getTemplateViewModel().filterDates.startDate(),
                endDate: this.tagPerformanceArticleReport_template.getTemplateViewModel().filterDates.endDate(),
                view: 'article',
            }
        };

        let usrReq_url: string = '';
        let usrReq_callback;
        switch (id){

            case 'primaryCategoriesFilter':{

                usrReq_url = '/api/topicalityReport/emakiCategorySuggestions/';
                usrReq_callback = this.onGetAutoCompleteCategoriesSuggestionsReturn;
                break;
            }
        }

        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)]);
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
        this.XHRHdl.onReadyStateFunction = usrReq_callback;
        this.XHRHdl.execute();
    }

    protected onGetAutoCompleteCategoriesSuggestionsReturn(req, obj){

        return function (){

            obj.manageResponse(req, obj, function (){

                let responseParsed = JSON.parse(req.request.response);
                if(req.request.status == 200){

                    obj.tagPerformanceArticleReport_template.setPrimaryCategoriesFilterItems(responseParsed.data);
                }
            });
        }
    }

    public getExportData(): void{

        this.loadingIn(this.tagPerformanceArticleReport_template.builtTemplate.children.namedItem("list-results"));

        this.XHRHdl.cancelAndReset();

        let subViewModel = this.tagPerformanceArticleReport_template.getViewModelForRequest();

        let usrReq_url: string = '/api/topicalityReport/article/export/';
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)] );
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url,usrReq_params, this);

        this.XHRHdl.onReadyStateFunction = this.onGetExportData;
        this.XHRHdl.execute();
    }

    protected onGetExportData(req, obj){

        return function () {

            obj.manageResponse(req, obj, function () {

                let responseParsed = JSON.parse(req.request.response);
                if (req.request.status == 200) {

                    obj.tagPerformanceArticleReport_template.validationsList.clearMessages();
                    obj.tagPerformanceArticleReport_template.setExportData(responseParsed);
                    obj.tagPerformanceArticleReport_template.exportData();
                }
            });

            obj.loadingOut(obj.tagPerformanceArticleReport_template.builtTemplate.children.namedItem("list-results"));
        }
    }
}



// WEBPACK FOOTER //
// ./js/modules/tagPerformanceArticleReport.ts